import React from 'react';
import './PageHeader.css';

function PageHeader({ onNavigate, viewMode, onViewModeChange }) {
  return (
    <div className="challenges-page-header">
      <button className="back-btn" onClick={() => onNavigate('dashboard')}>
        ← Back to Dashboard
      </button>
      <h1>🏆 Challenges</h1>
      
      <div className="header-controls">
        <div className="view-toggle">
          <button 
            className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
            onClick={() => onViewModeChange('list')}
            title="List View"
          >
            ☰
          </button>
          <button 
            className={`view-btn ${viewMode === 'card' ? 'active' : ''}`}
            onClick={() => onViewModeChange('card')}
            title="Card View"
          >
            ⊞
          </button>
        </div>
        
        <button className="create-challenge-btn" onClick={() => onNavigate('create-challenge')}>
          🏆 Create Challenge
        </button>
      </div>
    </div>
  );
}

export default PageHeader;

